<template>
  <div>
    <my-loader v-if="isLoading" />

    <div v-else-if="hasError && !trailer" class="state-block">
      <h2>Не удалось загрузить прицеп</h2>
    </div>

    <div v-else-if="trailer" :class="{ cards: !isWizardReturn }">
      <div v-if="isFetching" class="refresh-bar" />
      <div v-if="!isWizardReturn" class="header-content">
        <router-link :to="{ name: 'TrailerList' }" class="back-link">
          &larr; К списку прицепов
        </router-link>
      </div>

      <ExecutorWizardEditLayout
        v-if="isWizardReturn"
        title="Редактирование прицепа"
        description="Измените данные прицепа-исполнителя."
      >
        <TrailerForm
          mode="edit"
          :initial-data="trailer"
          :errors="formErrors"
          @update="onUpdate"
          @closeForm="closeForm"
        />
      </ExecutorWizardEditLayout>
      <div v-else class="card-item">
        <h2 class="detail-title">Прицеп № {{ trailer.number || '—' }}</h2>
        <TrailerForm mode="edit" :initial-data="trailer" :errors="formErrors" @update="onUpdate" />
        <guard-button
          :model="'cars'"
          :id="trailer.id"
          @reloadExecutor="onSecurityReload"
        />
      </div>

      <div v-if="securityInfo && !isWizardReturn" class="card-item">
        <CarSecurityInfo
          class="securiti-info"
          :car="{ vin: trailer.vin, number: trailer.number }"
          :security="securityInfo"
        />
      </div>
    </div>

    <div v-else class="state-block">
      <h2>Нет Данных</h2>
    </div>
  </div>
</template>

<script>
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'
import TrailerForm from '@/components/forms/TrailerForm.vue'
import CarSecurityInfo from '@/pages/securityCheck/components/CarSecurityInfo.vue'
import ExecutorWizardEditLayout from '@/components/UI/ExecutorWizardEditLayout.vue'
import { carSecurityInfo } from './carsState.mjs'
import { useCarPage } from './useCarsPage'
import { isExecutorWizardReturn, refreshWizardItem, returnToExecutorWizard } from './executorWizardReturn'
import { useExecutorWizardStore } from '@/stores/executorWizard'

export default {
  name: 'TrailerDetail',
  components: {
    TrailerForm,
    CarSecurityInfo,
    ExecutorWizardEditLayout,
  },
  setup() {
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const wizard = useExecutorWizardStore()
    const isWizardReturn = isExecutorWizardReturn(route)
    const trailerId = computed(() => route.params.id)

    // Прицеп — это машина с is_trailer=true; тот же endpoint /api/v2/cars.
    const { car, isLoading, isFetching, hasError, invalidateCar, refetch } = useCarPage(trailerId)
    const trailer = car

    const securityInfo = computed(() => carSecurityInfo(trailer.value))

    const formErrors = computed(
      () => store.state.apiStorage.cars.formErrors || {},
    )

    const onUpdate = async (form) => {
      const ok = await store.dispatch('apiStorage/updateItem', { model: 'cars', form })
      if (!ok) return
      await invalidateCar()
      await refetch()
      if (isExecutorWizardReturn(route)) {
        refreshWizardItem(wizard, route, trailer.value)
        await returnToExecutorWizard(router)
      }
    }

    const closeForm = () => {
      if (isExecutorWizardReturn(route)) returnToExecutorWizard(router)
    }

    const onSecurityReload = async () => {
      await invalidateCar()
    }

    return {
      trailer,
      isLoading,
      isFetching,
      hasError,
      securityInfo,
      formErrors,
      isWizardReturn,
      onUpdate,
      closeForm,
      onSecurityReload,
    }
  },
}
</script>

<style scoped>
.state-block {
  padding: 32px;
  color: #667085;
  text-align: center;
}

.cards {
  position: relative;
  display: flex;
  flex-direction: column;
  padding: 15px;
}

.refresh-bar {
  position: absolute;
  top: 0;
  left: 15px;
  right: 15px;
  height: 2px;
  background: linear-gradient(90deg, transparent, #4f46e5, transparent);
  animation: refresh-slide 1s linear infinite;
}

@keyframes refresh-slide {
  from { transform: translateX(-100%); }
  to { transform: translateX(100%); }
}

.card-item {
  border-radius: 10px;
  margin-top: 5px;
  border: 1px solid #ccc;
  padding: 15px;
}

.header-content {
  display: flex;
  justify-content: flex-start;
  margin-right: 20px;
  align-items: center;
}

.back-link {
  color: #007bff;
  text-decoration: none;
  font-size: 14px;
}

.back-link:hover {
  text-decoration: underline;
}

.detail-title {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: bold;
}
</style>
